import { render, staticRenderFns } from "./InformationCenter.vue?vue&type=template&id=206d4f0f&scoped=true"
import script from "./InformationCenter.vue?vue&type=script&lang=js"
export * from "./InformationCenter.vue?vue&type=script&lang=js"
import style0 from "./InformationCenter.vue?vue&type=style&index=0&id=206d4f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d4f0f",
  null
  
)

export default component.exports